
import ApiGenericServicesData from 'services/ApiGenericServicesData';

export default class CaptacionFallecidos extends ApiGenericServicesData{
    constructor(){
        super("captacionFallecidos");
    }
    captacionFallecido(data) { return this.customPOST("captacionFallecido", data); }
    obtenerFallecido(id) { return this.customPOST("obtenerFallecido",id); }
    eliminarFallecido(data) { return this.customDelete("eliminarFallecido",data); }
    modificarFallecido(data) { return this.customPUTModify("modificarFallecido",data); }
    obtenerDeptoMuni(data) { return this.customGET("obtenerDeptoMuni/"+data); }
    obtenerFolio(data) { return this.customGET("obtenerFolio/"+data.folio+'/'+data.año+'/'+data.origen); }
    visalizarpdf(id) { return this.customGET("visalizarpdf/"+id); }
    reporteFallecidosPdf(data) { return this.customPOST("reporteFallecidosPdf", data); }
    obtenerDocumento(id) { return this.customGET("obtenerDocumento/"+id); }
    subirDocumentoInvestigacion(data) { return this.customPOST("subirDocumentoInvestigacion", data); }
}